import { useState } from 'react';

const useCreateBlob = (data, report, resetData) => {
  const [downloadError, setDownloadError] = useState(false);

  const downloadDocument = () => {
    try {
      if (data) {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', report);
        document.body.appendChild(link);
        link.click();
        link.parentNode && link.parentNode.removeChild(link);
      }
    } catch (error) {
      setDownloadError(true);
    }

    resetData();
  };

  return { downloadDocument, downloadError };
};

export default useCreateBlob;
